import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function StudentJoin({ user, onLogout }) {
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleJoin = async (e) => {
    e.preventDefault();
    
    if (pin.length !== 6) {
      setError('El PIN debe tener 6 dígitos');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.get(`${BACKEND_URL}/api/sessions/pin/${pin}`);
      if (response.data) {
        navigate(`/play/${pin}`);
      }
    } catch (err) {
      setError('Sesión no encontrada. Verifica el PIN e intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-accent via-teal-500 to-blue-500 flex items-center justify-center p-4" data-testid="student-join-page">
      <div className="absolute top-4 right-4">
        <button
          onClick={onLogout}
          className="px-4 py-2 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition shadow-lg"
          data-testid="logout-btn"
        >
          Cerrar Sesión
        </button>
      </div>

      <div className="max-w-md w-full">
        {/* User Info */}
        <div className="text-center mb-8">
          {user.picture && (
            <img src={user.picture} alt={user.name} className="w-24 h-24 rounded-full mx-auto mb-4 border-4 border-white shadow-xl" />
          )}
          <h2 className="text-2xl font-bold text-white mb-2">Hola, {user.name}! 👋</h2>
          <p className="text-white text-opacity-90">Ingresa el PIN para unirte a un quiz</p>
        </div>

        {/* Join Form */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-6">
            <div className="text-5xl mb-4">🎯</div>
            <h3 className="text-2xl font-bold text-gray-800">Unirse a un Quiz</h3>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm" data-testid="error-message">
              {error}
            </div>
          )}

          <form onSubmit={handleJoin}>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">PIN de la Sesión</label>
              <input
                type="text"
                value={pin}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                  setPin(value);
                }}
                className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl text-center text-3xl font-bold tracking-widest focus:ring-2 focus:ring-accent focus:border-transparent"
                placeholder="000000"
                maxLength="6"
                data-testid="pin-input"
              />
              <p className="text-xs text-gray-500 mt-2 text-center">Ingresa el PIN de 6 dígitos proporcionado por tu profesor</p>
            </div>

            <button
              type="submit"
              disabled={loading || pin.length !== 6}
              className="w-full px-6 py-4 bg-accent text-white text-lg font-bold rounded-xl hover:bg-teal-500 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="join-btn"
            >
              {loading ? 'Verificando...' : 'Unirse al Quiz'}
            </button>
          </form>
        </div>

        {/* Info */}
        <div className="mt-6 text-center text-white text-opacity-90 text-sm">
          <p>💡 Tip: Asegúrate de ingresar el PIN correcto proporcionado por tu profesor</p>
        </div>
      </div>
    </div>
  );
}

export default StudentJoin;
